module.exports = __webpack_public_path__ + "static/img/chuzhongwuli.a2e0486e.jpg";